import {Injectable, inject} from "@angular/core";
import {AppToastService} from "./app-toast.service";
import {Router} from "@angular/router";

@Injectable()
export class ErrorHandlerService {
  private _toast = inject(AppToastService);
  private _router = inject(Router);

  constructor() {}

  httpErrorHandler(err: any) {
    const status = err["status"];
    if (status >= 500) {
      this._toast.error("globalErrors.serverErrorMessage");
    } else if (status === 403) {
      this._toast.error("globalErrors.forbiddenMessage");
    } else if (status === 409) {
      if (
        typeof err.message !== "string" &&
        err.message["field"] === "mobile"
      ) {
        this._toast.error("globalErrors.duplicateMobileMessage");
      }
    } else if (err?.error?.message?.response?.openOrders?.length > 0) {
      return;
    }
    // duplicate customer phone number
    else if (err?.error?.message?.response?.conflicts?.[0]?.mobile) {
      this._toast.error(
        `مشتری با شماره موبایل ${err?.error?.message?.response?.conflicts?.[0]?.mobile} قبلا ثبت نام کرده است!`,
        "",
        {},
        () => {
          this._router.navigateByUrl(
            `customers/view/wallet?customer_id=${err?.error?.message?.response?.conflicts?.[0]?.customer_id}`
          );
        }
      );
    } else if (status === 401) {
      this._toast.error("globalErrors.authorizationUnsuccessful");
    } else if (status === 400) {
      const customCode = (err.error.message as any)?.response?.code;
      if (customCode === 1001) {
        this._toast.error("categories.list.categoryHasProductErrorMessage");
      } else {
        this._toast.error(
          err.error?.message?.message || "globalErrors.generalErrorMessage"
        );
      }
    } else {
      this._toast.error("globalErrors.generalErrorMessage");
    }
  }
}
